<template>
    <Dropdown @on-click="handleClick" transer placement="right-start">
        <a class="drop-menu-a" type="text" :style="{textAlign: !hideTitle ? 'left' : ''}">
            <Icon :size="rootIconSize" :color="textColor" :type="parentItem.icon"/>
            <span class="menu-title" v-if="!hideTitle">{{ $t(parentItem.name).routerName }}</span>
            <Icon v-if="!hideTitle" :size="10" :color="textColor" type="chevron-right"
                  style="float: right;margin-top: 4px;"/>
        </a>
        <DropdownMenu slot="list">
            <template v-for="child in children">
                <collapsed-menu v-if="child.children" :icon-size="iconSize" :parent-item="child"
                                :key="`drop-${child.name}`"></collapsed-menu>
                <DropdownItem v-else :key="`drop-${child.name}`" :name="child.name">
                    <Icon :size="iconSize" :type="child.icon"/>
                    <span class="menu-title">{{ $t(child.name).routerName }}</span>
                </DropdownItem>
            </template>
        </DropdownMenu>
    </Dropdown>
</template>
<script>
import menuItemMixin from './menu-item-mixin';

export default {
    name: 'collapsedMenu',
    mixins: [menuItemMixin],
    props: {
        hideTitle: {
            type: Boolean,
            default: false,
        },
        rootIconSize: {
            type: Number,
            default: 16,
        },
    },
    methods: {
        handleClick(name) {
            this.$emit('on-click', name);
        },
    },
};
</script>
